import { render, staticRenderFns } from "./AccountTrusteeDetails.vue?vue&type=template&id=c453d69e&"
import script from "./AccountTrusteeDetails.vue?vue&type=script&lang=js&"
export * from "./AccountTrusteeDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports